export default "__VITE_ASSET__DO5yisu7__"